import { PlusCircleOutlined } from "@ant-design/icons";
import { Button, Image, Input, message, Pagination, Space, Switch, Table, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  IconEditPen,
  IconSearch,
  IconEdit,
  IconDelete,
  IconEmptyTable,
  IconRight,
} from "@assets";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import CreateProductOptions from "../CreateProductOptions/CreateProductOptions";
import api from "../../../api/api";
import CreateProduct from "./CreateProduct/CreateProduct";
import AddOptions from "./AddOptions/AddOptions";
import DeleteModal from "./DeleteModal/DeleteModal";
import UpdateStatusModal from "./UpdateStatusModal/UpdateStatusModal";
import { PRIVATE_ROUTE } from "../../../route.constants";
import EditProductOptions from "./EditProductOptions/EditProductOptions";
import LanguageBar from "../../../share/LanguageBar";
import InvoiceCodeModal from "../../TemplateManagement/EditTemplate/InvoiceCodeModal/InvoiceCodeModal";
import {
  GrayTitle,
  TitleWrapper,
  Topbar,
} from "../../Dashboard/BestSellingProducts";
import { IconLeft } from "../../../assets/icons";
import { SubTitle } from "../UserManagement/UserManagement";
import { useAtom } from "jotai";
import { savedProductTablePage } from "../../../utils/atom";
import { useTranslation } from "react-i18next";

const RootContainer = styled.div`
  .ant-table-placeholder {
    display: none;
  }

  .ant-table svg {
    cursor: pointer;
  }

  .ant-table-wrapper .ant-spin {
    height: 200px !important;
  }

  .icon-disabled {
    > :first-child {
      fill: #f5f5f5 !important;
    }
    > :last-child {
      fill: #cccccc !important;
    }
  }
`;

const Title = styled.div`
  padding-top: 16px;
  padding-bottom: 24px;
  font-size: 24px;
  font-weight: 700;
  color: #1e1e1e;
`;

export const OptionCard = styled.div`
  padding: 16px 24px;
  display: flex;
  flex-direction:row;
  gap: 16px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: ${(props) => props.theme.backgroundColor};

  .ant-btn-primary {
    height: 48px;
    width: 172px;
  }

  .ant-space {
    gap: 8px;
  }

  svg {
    cursor: pointer;
  }

@media (max-width: 480px) {
 align-items: start;
 flex-direction:column;
}


`;

export const OptionsWrapper = styled.div`
  flex: 1;
  display: flex;
  gap: 4px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const Text = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #1e1e1e;
  text-overflow: ellipsis;
`;

export const LightText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #868686;
`;

export const OptionItem = styled.div`
  padding: 8px 12px;
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: flex-start;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.primaryColor};
  cursor: pointer;
  max-width: 500px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  div {
    font-size: 14px;
    font-weight: 600;
  }
`;

const TopWrapper = styled.div`
  margin: 24px 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-center;
  gap: 16px;

  .ant-btn-primary {
    height: 48px;
    width: 172px;
  }
  @media (max-width: 480px) {
 align-items: start;
 flex-direction:column;
}
`;

const InputWrapper = styled.div`
  flex: 1;

  .ant-input {
    max-width: 300px;
   
  }
`;

const EmptyBox = styled.div`
  padding-top: 48px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

const OptionsCard = ({ options, goToCreateOptions }) => {
  const navigate = useNavigate();
  const goToEditProductOptions = (id) => {
    navigate(`edit-product-options/${id}`);
  };
  
  const {t} = useTranslation();

  return (
    <OptionCard>
      <OptionsWrapper>
        <Text>{t('product_option')} ({options.length})</Text>
        <LightText>
          {t('general_options_text')}
        </LightText>
        <Space wrap>
          {options?.map((opt, key) => (
            <OptionItem
              key={key}
              onClick={() => goToEditProductOptions(opt.id)}
            >
              <Text style={{ overflow: "clip", maxWidth: "150px" }}>
                {opt.name}
              </Text>
              <IconEditPen primaryColor />
            </OptionItem>
          ))}
        </Space>
      </OptionsWrapper>
      <Button
        type="primary"
        icon={<PlusCircleOutlined />}
        onClick={goToCreateOptions}
      >
        {t('create_option')}
      </Button>
    </OptionCard>
  );
};

const Products = () => {
  const [savedProductPage,setSavedProductPage] = useAtom(savedProductTablePage);
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [options, setOptions] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [openDelete, setOpenDelete] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const [currentPage, setCurrentPage] = useState(savedProductPage ?? 1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText, setDebouncedSearchText] = useState("");
  const [openInvoiceCodeModal, setOpenInvoiceCodeModal] = useState(false);
  const [panelInfo, setPanelInfo] = useState();
  const [shortCode, setShortCode] = useState("");
 
 const {t} = useTranslation();

  // useEffect(() => {
  //   const handler = setTimeout(() => {
  //     setDebouncedSearchText(searchText);
  //     setCurrentPage(1);
  //     setSavedProductPage(1);
  //     getProducts({ search: searchText, page: 1, pageSize });
  //   }, 500);

  //   return () => clearTimeout(handler);
  // }, [searchText, pageSize]);

  useEffect(() => {
  const handler = setTimeout(() => {
    setDebouncedSearchText(searchText);
    if (searchText) {
      setCurrentPage(1);
      setSavedProductPage(1);
      getProducts({ search: searchText, page: 1, pageSize });
    } else {
      getProducts({ search: "", page: savedProductPage || currentPage, pageSize });
    }
  }, 500);

  return () => clearTimeout(handler);
}, [searchText]);


  const getProducts = ({
    search = "",
    page = currentPage,
    pageSize = pageSize,
  } = {}) => {
    setLoading(true);
    api
      .getProducts({
        search,
        page,
        page_size: pageSize,
      })
      .then(({ currentPage, rowPerPage, total, data }) => {
        setData(data);
        setLoading(false);
        setCurrentPage(currentPage);
        setPageSize(rowPerPage);
        setTotal(total);
      })
      .catch((error) => {
        message.error(error?.message || t('fails_fetch_products'));
        setLoading(false);
      });
  };

  const getProductOptions = () => {
    api
      .getProductOptions()
      .then(({ data }) => {
        setOptions(data);
      })
      .catch((error) => {
        message.error(error);
      });
  };

  useEffect(() => {
    getProductOptions();
    getProducts({ page: savedProductPage || 1, pageSize });
    getPanelInfo();
    // eslint-disable-next-line
  }, []);

  const getPanelInfo = () => {
    api
      .getPanelInfo()
      .then(({ data }) => {
        setPanelInfo(data);
      })
      .catch((error) => {
        message.error(error);
      });
  };

  const goToCreateOptions = () => {
    navigate(`create-options`);
  };

  const goToCreateProduct = () => {
    panelInfo?.shortCode
      ? navigate(`create-product`)
      : setOpenInvoiceCodeModal(true);
  };

  const handleDeleteItemClicked = (item) => {
    setSelectedItem(item);
    setOpenDelete(true);
  };

  const handleStatusClicked = (item) => {
    setSelectedItem(item);
    setOpenStatus(true);
  };

  const handleClose = () => {
    setOpenDelete(false);
    setOpenStatus(false);
    setSelectedItem({});
  };

  const successCallback = () => {
    getProducts({ search: searchText, page: currentPage, pageSize });
  };

  const statusSuccessCallback = (id) => {
    setData((prev) =>
      prev?.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            status: !item.status,
          };
        }
        return item;
      })
    );
  };

  const goToDetails = (item) => {
    navigate(
      `/${PRIVATE_ROUTE.HOME}/${PRIVATE_ROUTE.PRODUCT_DETAILS}/${item.id}`
    );
    setSavedProductPage(currentPage)
  };

  const handleShortCodeSuccess = (code) => {
    setShortCode(code);
    getPanelInfo();
  };

  const goToEditProduct = (item) => {
    navigate(`/${PRIVATE_ROUTE.HOME}/${PRIVATE_ROUTE.EDIT_PRODUCT}/${item.id}`);
  };

  const categoryFilters = [
    ...new Set(
      data.map((item) => item.category?.name?.primary).filter(Boolean)
    ),
  ].map((cat) => ({ text: cat, value: cat }));

  const catalogueFilters = [
    ...new Set(
      data
        .flatMap((item) => item.catalogue?.map((cat) => cat?.name?.primary))
        .filter(Boolean)
    ),
  ].map((cat) => ({ text: cat, value: cat }));

  const statusFilter = [
    { text: t('active'), value: true },
    { text: t('inactive'), value: false },
  ];

  const columns = [
    {
      key: "id",
      title: t('no.'),
      render: (_, record, index) => {
        return (currentPage - 1) * pageSize + index + 1;
      },
    },
   {
    key: "name",
    dataIndex: "name",
    title: t("products"),
    sorter: (a, b) =>
      a.name.primary.localeCompare(b.name.primary),

    render: (_, record) => (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          minWidth: 0,
        }}
      >
        <div
          style={{
            width: 60,
            height: 60,
            minWidth: 60,
            borderRadius: 12,
            overflow: "hidden",
            background: "#F5F5F5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Image
            src={record?.thumb_image}
            alt="product-image"
            width={60}
            height={60}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            minWidth: 0,
          }}
        >
         <Tooltip title={record.name?.primary}>
          <div
            style={{
              fontWeight: 600,
              fontSize: 14,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "180px",
              cursor: "pointer",
            }}
          >
            {record.name?.primary?.length > 15
              ? `${record.name.primary.slice(0, 15)}...`
              : record.name?.primary}
          </div>
        </Tooltip>
         <Tooltip title={record.name?.secondary}>
          <div
            style={{
              fontWeight: 600,
              fontSize: 14,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "180px",
              cursor: "pointer",
            }}
          >
            {record.name?.secondary?.length > 15
              ? `${record.name.secondary.slice(0, 15)}...`
              : record.name?.secondary}
          </div>
        </Tooltip>
        </div>
      </div>
    ),
  },
    {
      key: "variant_count",
      title: t('variant_count'),
      sorter: (a, b) =>
        String(a?.variant_count).localeCompare(String(b?.variant_count)),
      render: (_, record, index) => record.variant_count,
    },
    {
      key: "category",
      dataIndex: "category",
      title: t('categories'),
      filters: categoryFilters,
      onFilter: (value, record) => record.category?.name?.primary === value,
      render: (_, record) => (
        <div>
          {`${record.category?.name?.primary} / ${record.sub_category?.name?.primary}`}
        </div>
      ),
    },
    {
      key: "catalogues",
      dataIndex: "catalogues",
      title: t('catalogue'),
      filters: catalogueFilters,
      onFilter: (value, record) =>
        record.catalogue?.some((item) => item?.name?.primary === value),
      render: (_, record) =>
        record?.catalogue?.map((item, key) => (
          <span key={key}>
            {item?.name?.primary}
            {record.catalogue?.length > 1 &&
              key !== record.catalogue?.length - 1 &&
              ", "}
          </span>
        )),
    },
    {
      key: "is_active",
      dataIndex: "is_active",
      title: t('status'),
      filters: statusFilter,
      onFilter: (value, record) => record.status === value,
      render: (_, record) => (
        <Switch
          value={record.status}
          onClick={() => handleStatusClicked(record)}
        />
      ),
    },
    {
      key: "actions",
      title: t('actions'),
      render: (_, record) => (
        <Space>
          <IconEdit onClick={() => goToEditProduct(record)} />
          <IconDelete onClick={() => handleDeleteItemClicked(record)} />
          <IconRight onClick={() => goToDetails(record)} />
        </Space>
      ),
    },
  ];

  const EmptyCard = () => (
    <EmptyBox>
      <IconEmptyTable />
      <LightText>
        {t('no_product_text')}
      </LightText>
    </EmptyBox>
  );

  const goBack = () => {
    navigate(-1);
  };

  return (
    <RootContainer>
      <LanguageBar />
      {location.state === "dashboard" && (
        <Topbar>
          <Button type="default" icon={<IconLeft />} onClick={goBack}>
            {t('back')}
          </Button>
          <TitleWrapper>
            <GrayTitle>{t('dashboard')}</GrayTitle>
            <IconRight />
            <SubTitle>{t('total_products')}</SubTitle>
          </TitleWrapper>
        </Topbar>
      )}
      <Title>{t('main_products')} ({data.length})</Title>
      {/* <OptionsCard options={options} goToCreateOptions={goToCreateOptions} /> */}
      <TopWrapper>
        <InputWrapper>
          <Input
            prefix={<IconSearch />}
            placeholder={t('search_by_product')}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            allowClear
             style={{
              width: "clamp(220px, 90vw, 400px)",
            }}
          />
        </InputWrapper>
        <Button
          type="primary"
          icon={<PlusCircleOutlined />}
          onClick={goToCreateProduct}
        >
          {t('create_product')}
        </Button>
      </TopWrapper>
      <InvoiceCodeModal
        open={openInvoiceCodeModal}
        handleClose={() => setOpenInvoiceCodeModal(false)}
        successCallback={handleShortCodeSuccess}
      />
      <Table
        dataSource={data
          ?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
          .map((item) => item)}
        columns={columns}
        pagination={false}
        loading={loading}
        rowKey="id"
        scroll={{ x: 900 }}
      />

      {!loading && data.length === 0 && <EmptyCard />}

      <Pagination
        current={currentPage}
        pageSize={pageSize}
        total={total}
        onChange={(page, size) => {
          setCurrentPage(page);
           setSavedProductPage(page);
          setPageSize(size);
          getProducts({ search: searchText, page, pageSize: size });
        }}
        showSizeChanger
        pageSizeOptions={["5", "10", "20", "50", "100"]}
        style={{
          marginTop: 16,
          textAlign: "right",
          marginLeft: "auto",
          width: "fit-content",
        }}
      />

      <DeleteModal
        open={openDelete}
        id={selectedItem.id}
        handleClose={handleClose}
        successCallback={successCallback}
      />
      <UpdateStatusModal
        open={openStatus}
        id={selectedItem.id}
        handleClose={handleClose}
        successCallback={statusSuccessCallback}
      />
    </RootContainer>
  );
};

const Entry = () => {
  return (
    <Routes>
      <Route path="" element={<Products />} />
      <Route path={`/create-options`} element={<CreateProductOptions />} />
      <Route
        path="/edit-product-options/:id"
        element={<EditProductOptions />}
      />
      <Route path={`/create-product`} element={<CreateProduct />} />
      <Route path="/create-product/add-options" element={<AddOptions />} />
    </Routes>
  );
};

export default Entry;
